import React from 'react';
import { Avatar } from 'antd';
import useAuthenticatedAvatarSource from '../../hooks/useAuthenticatedAvatarSource';

const AuthenticatedAvatar = ({ src, onError, ...avatarProps }) => {
    const { imageSource, handleImageError } = useAuthenticatedAvatarSource(src);

    const handleError = () => {
        handleImageError();
        return onError?.();
    };

    return (
        <Avatar
            {...avatarProps}
            src={imageSource || undefined}
            onError={handleError}
        />
    );
};

export default AuthenticatedAvatar;
